import styles from './PageContent.module.css';
import { Link } from 'react-router-dom';

function PageContent({ title, children }) {
  return (
    <div>
    <div className={styles["page-wrap"]}>
      <div className={styles["page-not-found"]}>
        
        <h1 className={styles["text-xl"]}>
          <span>4</span>
          <span>0</span>
          <span className={styles.broken}>4</span>
        </h1>
        <h4 className={styles["text-md"]}>{title}!</h4>
        <h4 className={`${styles["text-sm"]} ${styles["text-sm-btm"]}`}>
        {children}
          <Link to='/dashboard' className="btn btn-link me-4">Previous Page</Link>
        </h4>
      </div>
    </div>
  </div>
    // <div className={classes.content}>
    //   <h1></h1>
    //   {children}
    // </div>
  );
}

export default PageContent;
